import React from 'react';

const Footer = ({ t }) => {
  return (
    <footer data-testid="footer" className="bg-white py-10 sm:py-12 border-t border-gray-200">
      <div className="container mx-auto px-5 sm:px-6 lg:px-8 max-w-6xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 pb-8 border-b border-gray-100">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <img src="/images/logos/recurso_63.svg" alt="Hexaparks" className="h-6 w-auto" />
              <div className="flex flex-col items-center leading-none">
                <img src="/images/logos/hexaparks_wordmark.svg" alt="Hexaparks" className="h-3 w-auto" />
                <span className="text-[6px] text-gray-500 tracking-[0.15em] uppercase mt-[1px]">{t.logo?.slogan}</span>
              </div>
            </div>
            <p className="text-xs text-gray-500">{t.footer.tagline}</p>
          </div>

          {/* Address */}
          <div>
            <p className="text-xs text-gray-600 leading-relaxed">{t.footer.address}</p>
            <a href={`mailto:${t.footer.email}`} className="text-xs text-gray-900 hover:text-gray-600 mt-2 inline-block">
              {t.footer.email}
            </a>
          </div>

          {/* Legal */}
          <div className="text-xs text-gray-500 space-y-2">
            <a href="#" className="block hover:text-gray-700">{t.footer.legal}</a>
            <a href="#" className="block hover:text-gray-700">{t.footer.privacy}</a>
          </div>

          {/* Social */}
          <div>
            <p className="text-xs text-gray-400 uppercase tracking-wider mb-3">{t.footer.social}</p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-gray-400 hover:text-gray-600" aria-label="LinkedIn">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-gray-600" aria-label="Instagram">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-gray-600" aria-label="X">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
            </div>
          </div>
        </div>

        <div className="pt-6 text-center text-xs text-gray-400">
          {new Date().getFullYear()} Hexaparks
        </div>
      </div>
    </footer>
  );
};

export default Footer;
